import { BaseType, HierarchyNode, HierarchyRectangularNode, Selection, Transition } from 'd3';
import { MarketMapData } from '../../shared/models/market-data.model';
import { ISymbol } from '../../shared/models/symbol.model';

export interface TreeRoot {
	value?: number;
	name: string;
	groupIndex?: string;
	isin?: string;
	data?: Partial<MarketMapData> &
		ISymbol & {
			lastPriceVar?: number;
			closingPriceVar?: number;
			historicalData_monthly?: number;
			historicalData_quarterly?: number;
			historicalData_halfYearly?: number;
			historicalData_yearly?: number;
		};
	children?: this[];
}

export type Hierarchy = HierarchyNode<TreeRoot>;
export type HierarchyRectangular = HierarchyRectangularNode<TreeRoot>;

export type TreeElement<
	GElement extends BaseType = SVGElement,
	PElement extends BaseType = HTMLElement,
	Datum = HierarchyRectangular,
	PDatum = HierarchyRectangular
> = Selection<GElement, Datum, PElement, PDatum>;

export type TreeTransition<
	GElement extends BaseType = SVGElement,
	PElement extends BaseType = HTMLElement,
	Datum = HierarchyRectangular,
	PDatum = HierarchyRectangular
> = Transition<GElement, Datum, PElement, PDatum>;

export enum MarketMapVolumeIndex {
	Equal = 'equal',
	TotalTradeValue = 'totalTradeValue',
	TotalNumberOfSharesTraded = 'totalNumberOfSharesTraded',
	TotalNumberOfTrades = 'totalNumberOfTrades'
}

export enum TreeMapCategoryType {
	BySector,
	All,
	ByFlow,
	ByMarketUnit
}

export enum TreeMapSourceType {
	Total,
	Portfolio,
	Watch
}
export enum TreeMapOptionSourceType {
	OptionSymbol = 1,
	BaseSymbol = 2
}

export const isSelection = <E extends BaseType, P extends BaseType>(
	element: TreeElement<E, P> | TreeTransition<E, P>
): element is TreeElement<E, P> => (element as TreeElement<E, P>).append !== undefined;
